import conf from '../config/api.js';
import Vue from 'vue';
import script from './script.js'
import vuexStorage from '../store/index.js'
var moment = require('moment');
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
    new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
    new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

async function getVcfInfo(input) {
    input = input.replace(/\r\n[ \t]/g, '')
                .replace(/\n[ \t]/g, '')
                .replace(/\r[ \t]/g, '');

    const Re1 = /^(version|fn|title|org|note|n):(.+)$/i;
    const Re2 = /^([^:;]+);([^:]+):(.+)$/;
    const ReKey = /item\d{1,2}\./;
    const fields = {};

    const lines = input.split(/\r\n|\r|\n/);
    let i = 0;

    while (i < lines.length) {
        let line = lines[i];
        let results, key;

        if (Re1.test(line)) {
            results = line.match(Re1);
            key = results[1].toLowerCase();
            let value = results[2];

            while (
                i + 1 < lines.length &&
                !/^[A-Z0-9\-]+[:;]/i.test(lines[i + 1]) &&
                !/^END:VCARD/i.test(lines[i + 1])
            ) {
                i++;
                value += ' ' + lines[i].trim();
            }

            if (key === 'n') {
                const parts = value.split(';');
                fields['contact'] = {
                    lastName: parts[0] || '',
                    firstName: parts[1] || '',
                    additionalNames: parts[2] || '',
                    prefix: parts[3] || '',
                    suffix: parts[4] || ''
                };
            } else if (key === 'org') {
                const parts = value.split(';');
                fields[key] = {
                    organization: parts[0] || '',
                    unit: parts[1] || ''
                };
            } else if (key === 'note') {
                fields[key] = value.replace(/\s+/g, ' ').trim();
            } else {
                fields[key] = value;
            }

        } else if (Re2.test(line)) {
            results = line.match(Re2);
            key = results[1].replace(ReKey, '').toLowerCase();

            const meta = {};
            results[2].split(';')
                .map((p, i) => {
                    const match = p.match(/([a-z]+)=(.*)/i);
                    return match ? [match[1], match[2]] : ["TYPE" + (i === 0 ? "" : i), p];
                })
                .forEach(p => {
                    meta[p[0]] = p[1];
                });

            const valueParts = results[3].split(';');

            let value = valueParts;
            if (key === 'adr') {
                value = {
                    poBox: valueParts[0] || '',
                    extendedAddress: valueParts[1] || '',
                    street: valueParts[2] || '',
                    city: valueParts[3] || '',
                    region: valueParts[4] || '',
                    postalCode: valueParts[5] || '',
                    country: valueParts[6] || ''
                };
            }

            if (!fields[key]) fields[key] = [];
            fields[key].push({
                meta: meta,
                value: value
            });
        }

        i++;
    }

    return fields;
}

//Fonction d'ajout d'un contact
async function addContact(formData) {
  try {
    await requestApi({
      method: 'POST',
      url: '/api/addContact',
      form: formData,
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.$bvToast.toast(`Le contact a été ajouté`, {
      title: 'Ajout d\'un contact',
      toaster: 'b-toaster-bottom-right',
      variant: 'success',
      autoHideDelay: 2500,
      appendToast: true,
      solid: true
    });
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Ajout de contact impossible`,'Ajout de contact')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      this.$router.push('../login')
    }
  }
}

//Fonction d'ajout en masse de compte
function addMassiveContact(){
  for(var i=0;i<this.selectedContact.length;i++){
    script.iterateMassiveContact.call(this,this.selectedContact[i],this.templateSelected);
  }
}

//Fonction de connexion sur un compte client un compte admin
async function connectOnClient(clientId,socId){
  var connected = confirm("Voulez-vous vous connecter au compte de ce client?");
  if(connected){
    try {
      var response = await requestApi({
        method:"POST",
        url:"/api/connectAdminClient",
        params:{},
        form:{clientId: clientId, socid: socId},
        headers:{'Content-Type': 'application/json'}
      });
      this.$router.push(response.route);
    } catch (error) {
      if(error.response != undefined){
        toasterError(`Connexion au compte client impossible`,'Connexion compte client')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        this.$router.push('login');
      }  
    }
  }
}

//Fonction de création d'accès client
async function createAccess(email,contenuMail,pwd,tokenReinit,socid){
  try {
    await requestApi({
      method: 'POST',
      url: '/api/createAccess',
      form: {email: email, contenuMail: contenuMail, pwd: pwd, socid: socid, tokenReinit:tokenReinit},
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    alert("Accès créée avec succès!");
    await loadingClient.call(this);
    await expandClientInfo.call(this, socid);
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Création d'accès impossible`,'Création d\'accès')
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      this.$router.push('/');
    }
  }
}

//Fonction de suppression d'un contact
async function delContact(id) {
  try {
    await requestApi({
      method: 'POST',
      url: '/api/delContact',
      form: {id:id},
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.$bvToast.toast(`Le contact a été supprimé`, {
      title: 'Suppression d\'un contact',
      toaster: 'b-toaster-bottom-right',
      variant: 'success',
      autoHideDelay: 2500,
      appendToast: true,
      solid: true
    });
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Suppression de contact impossible`,'Suppression de contact')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction de suppression d'accès client
async function deleteAccess(contactid,socid){
  if(confirm("Etes-vous sûr de vouloir supprimer l'accès à l'extranet de ce client?")){
    try {
      await requestApi({
        method: 'POST',
        url: '/api/deleteAccess',
        form: {id: contactid},
        params: {},
        headers: { 'Content-Type': 'application/json' }
      });
      await expandClientInfo.call(this, socid);
    } catch (error) {
      if(error.response != undefined){
        toasterError(`Suppression d'accès impossible`,'Suppression d\'accès')
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        this.$router.push('/');
      }
    }
  }
}

//Fonction de suppression de propale
async function deletePropale(id){
  var deleteDevis = confirm("Etes-vous sûr de vouloir supprimer ce devis?");
  if(deleteDevis == true){
    try {
      await requestApi({
        method: 'POST',
        url: '/api/deletePropale',
        form: {id: id},
        params: {},
        headers: { 'Content-Type': 'application/json' }
      });
      toasterSuccess(`Suppression de devis réussie`,'Suppression de devis')
      vuexStorage.commit("delProposal",id)
    } catch {
      toasterError(`Suppression de devis échouée`,'Suppression de devis')
    }
  }
}

//Fonction de suppression de tiers
async function deleteTiers(id){
  var deleteClient = confirm("Voulez-vous supprimer le tiers?");
  if(deleteClient == true){
    try {
      const response = await requestApi({
        method: 'POST',
        url: '/api/deleteTiers',
        form: {id:id},
        params: {},
        headers: { 'Content-Type': 'application/json' }
      });
      if(response != 0){
        this.$bvToast.toast(`Le tiers à été supprimé avec succès`, {
          title: 'Suppression de tiers',
          toaster: 'b-toaster-bottom-right',
          variant: 'success',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        })
        await loadingClient.call(this);
      }else{
        this.$bvToast.toast(`Le tiers ne peut pas être supprimé car il y a un document en cours d'édition`, {
          title: 'Suppression de tiers',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        })
        await loadingClient.call(this);
      }
    } catch {
      this.$bvToast.toast(`Suppression impossible`, {
        title: 'Suppression de tiers',
        toaster: 'b-toaster-bottom-right',
        variant: 'danger',
        autoHideDelay: 2500,
        appendToast: true,
        solid: true
      })
    }
  }
}

//Fonction de chargement des infos des clients
async function detailsTiers(id,that) {
  if (!that) {
    that = this
  }
  try {
    const response = await requestApi({
      method: 'GET',
      url: '/api/detailsTiers',
      params: {id: id},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    vuexStorage.commit('updateInfoSoc', response)
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Impossible de charger les détails du tiers`,'Détails du tiers')
      if(error.response.status!=404){
        that.$router.push('../login');
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      that.$router.push('../tiers');
    }
  }
}

//Fonction de chargement des infos d'accès du client
async function expandClientInfo(id){
  try {
    const clientsExtranet = await requestApi({
      method: 'GET',
      url: '/api/verifyAccess/' + id,
      params: {},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.clientsExtranet = clientsExtranet;
    const contacts = await requestApi({
      method: 'GET',
      url: '/api/loadingContacts',
      params: {id: id},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.infosContacts = contacts;
    for(var j=0; j<this.infosContacts.length; j++){
      this.infosContacts[j]["acces"]=false;
    }
    for(var i=0; i<this.clientsExtranet.length; i++){
      for(j=0; j<this.infosContacts.length; j++){
        if((this.infosContacts[j]["id"]==this.clientsExtranet[i]["contactid"])||(this.infosContacts[j]["id"]==this.clientsExtranet[i]["contact_id"])){
          this.infosContacts[j]["acces"]=true;
          var dateC = new Date(this.clientsExtranet[i]["datec"]*1000);
          var jour = dateC.getDate();
          if(jour < 10){
            jour = '0' + jour;
          }
          var mois = dateC.getMonth()+1;
          if (mois < 10) { 
            mois = '0' + mois; 
          }
          var annee = dateC.getFullYear();
          this.infosContacts[j]["datec"]=annee+"-"+mois+"-"+jour;
        }
      }
    }
  } catch (error) {
    try {
      const contacts = await requestApi({
        method: 'GET',
        url: '/api/loadingContacts',
        params: {id: id},
        form: {},
        headers: { 'Content-Type': 'application/json' }
      });
      this.infosContacts = contacts;
    } catch (error2) {
      if(error2.response != undefined){
        toasterError(`Chargement des contacts impossible`,'Chargement des contacts')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
    if(error.response != undefined){
      toasterError(`Impossible d'effectuer la vérification`,'Verification')
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction de chargement des clients
async function loadingClient(){
  try {
    let clientsExtranet;
    if(this.$route.params.id){
      clientsExtranet = await requestApi({
        method: 'GET',
        url: '/api/verifyAccess/' + this.$route.params.id,
        params: {},
        form: {},
        headers: { 'Content-Type': 'application/json' }
      });
    } else {
      clientsExtranet = await requestApi({
        method: 'GET',
        url: '/api/verifyAccess',
        params: {},
        form: {},
        headers: { 'Content-Type': 'application/json' }
      });
    }
    this.clientsExtranet = clientsExtranet;
    const tiers = await requestApi({
      method: 'POST',
      url: '/api/loadingClient',
      params: {},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.tiers = tiers;
    this.numberOfPages = this.tiers.length / this.perPage;
    for(var j=0; j<this.tiers.length; j++){
      this.tiers[j]["acces"]=false;
      this.tiers[j]["_showDetails"]=false;
    }
    for(var i=0; i<this.clientsExtranet.length; i++){
      for(j=0; j<this.tiers.length; j++){
        if(this.tiers[j]["id"]==this.clientsExtranet[i]["socid"]){
          this.tiers[j]["acces"]=true;
        }
      }
    }
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Impossible de charger les clients`,'Chargement des clients')
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction de chargement des dictionnaires
async function loadingDictionary(){
  this.optionsPayment.push({value: "0",text: ""})
  this.optionsDeliveryDelay.push({value: "0",text: ""})
  try {
    const response = await requestApi({
      method: 'GET',
      url: '/api/getDictionary',
      params: {},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    var conditionPayment = response.conditionPayment
    var typePayment = response.typePayment
    var deliveryDelay = response.deliveryDelay
    var i
    for(i=0;i<conditionPayment.length;i++){
      this.optionsConditionsPayment.push({value: conditionPayment[i].id, text: conditionPayment[i].label})
    }
    for(i=0;i<typePayment.length;i++){
      this.optionsPayment.push({value:typePayment[i].code, text: typePayment[i].label})
    }
    for(i=0;i<deliveryDelay.length;i++){
      this.optionsDeliveryDelay.push({value: deliveryDelay[i].code, text: deliveryDelay[i].label})
    }
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Impossible de charger les dictionnaires`,'Chargement des dictionnaires')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction pour la selection pour l'ajout de masse à l'extranet
async function openAjoutExtranet(target){
  try {
    const clientsExtranet = await requestApi({
      method: 'GET',
      url: '/api/verifyAccess',
      params: {},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.clientsExtranet = clientsExtranet;
    const contacts = await requestApi({
      method: 'GET',
      url: '/api/loadingAllContacts',
      params: {},
      form: {},
      headers: { 'Content-Type': 'application/json' }
    });
    var res = contacts;
    for(var j=0; j<res.length; j++){
      res[j]["acces"]=false;
    }
    for(var i=0; i<this.clientsExtranet.length; i++){
      for(j=0; j<res.length; j++){
        if(res[j]["id"]==this.clientsExtranet[i]["contact_id"]){
          res[j]["acces"]=true;
        }
      }
    }
    for(j=0; j<res.length; j++){
      if(res[j]["acces"]==false){
        this.contacts.push(res[j]);
      }
    }
    this.$root.$emit('bv::show::modal', 'modalAjoutExtranet',target);
  } catch (error) {
    try {
      const contacts = await requestApi({
        method: 'POST',
        url: '/api/loadingAllContacts',
        params: {},
        form: {},
        headers: { 'Content-Type': 'application/json' }
      });
      this.contacts = contacts;
      for(var j=0; j<this.contacts.length; j++){
        this.contacts[j]["acces"]=false;
      }
      this.$root.$emit('bv::show::modal', 'modalAjoutExtranet',target);
    } catch (error2) {
      if(error2.response != undefined){
        toasterError(`Chargement des contacts impossible`,'Chargement des contacts')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction de mise à jours des champs
async function updateFields(type, id, field, value) {
  try {
    await requestApi({
      method: 'POST',
      url: '/api/updateFields',
      form: {type:type,id:id,field:field,value:value},
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.$bvToast.toast(`Les modifications ont été enregistrées`, {
      title: 'Modification rapide',
      toaster: 'b-toaster-bottom-right',
      variant: 'success',
      autoHideDelay: 2500,
      appendToast: true,
      solid: true
    });
  } catch {
    this.$router.push('../login')
  }
}

//Fonction de validation de propale
async function validateObject(type, id){
  try {
    await requestApi({
      method: 'POST',
      url: '/api/validateObject',
      form: {type: type, id: id},
      params: {},
      headers: { 'Content-Type': 'application/json' }
    });
    this.proposals = []
    script.loadDocuments("proposals");
  } catch {
    toasterError(`Une erreur interne est survenue`,'Erreur interne')
  }
}

//Fonction de visualisation des devis client admin
function visualDevisTiers(item,target){
  let src = conf.server+"/api/visualDoc/"+item.last_main_doc;
  let title ="Document "+item.ref+" : "+item.ref_client+" du "+moment(item.datec*1000).format("L");
  vuexStorage.commit("setModalDoc",{src:src, title:title})
  this.$root.$emit('bv::show::modal', 'modalVisualDevisTiers',target);
}

//Fonction de visualisation des factures client admin
function visualFacTiers(item,target){
  this.visualSrcFacTiers = conf.server+"/api/visualDoc/"+item.last_main_doc;
  this.modalVisualFacTiers.title="Document "+item.ref+" : "+item.ref_client+" du "+item.date_creation;
  this.$root.$emit('bv::show::modal', 'modalVisualFacTiers',target);
}

//Fonction qui analyze les fiches VCF
async function analyzeContact (fileList) {
  if(fileList.length){
    const promises = Array.from(fileList).map((file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async function (e) {
        try {
          const content = e.target.result;
          const data = await getVcfInfo(content);
          const contact = {
            firstname: data.contact && data.contact.firstName ? data.contact.firstName : '',
            lastname: data.contact && data.contact.lastName ? data.contact.lastName : '',
            privateNote: ((data.contact && data.contact.prefix) || '') + ' ' + ((data.contact && data.contact.suffix) || ''),
            title: data.title || '',
            organization: data.org && data.org.organization ? data.org.organization : '',
            phone: (data.tel && data.tel[0] && data.tel[0].value && data.tel[0].value[0]) ? data.tel[0].value[0] : '',
            email: (data.email && data.email[0] && data.email[0].value && data.email[0].value[0]) ? data.email[0].value[0] : '',
            url: (data.url && data.url[0] && data.url[0].value && data.url[0].value[0]) ? data.url[0].value[0] : '',
            note: data.note || '',
            address: (data.adr && data.adr[0] && data.adr[0].value && data.adr[0].value.street) ? data.adr[0].value.street : '',
            zip: (data.adr && data.adr[0] && data.adr[0].value && data.adr[0].value.postalCode) ? data.adr[0].value.postalCode : '',
            town: (data.adr && data.adr[0] && data.adr[0].value && data.adr[0].value.city) ? data.adr[0].value.city : '',
            isTiersCreated: false,
            isContactCreated: false,
          };
          resolve(contact);
          } catch (err) {
            reject(err);
          }
        };

        reader.onerror = reject;
        reader.readAsText(file);
      });
    });

    var results = await Promise.all(promises);
    try {
      let contactsVerified = await requestApi({method: 'POST', url: '/api/verifyContact', params: {}, form: {contacts : results}, headers: {'Content-Type': 'application/json'}})
      this.contactsList = contactsVerified
    } catch (error) {
      if(error.response != undefined){
        toasterError(`Impossible d'analyser les fiches VCF`,'Analyse VCF')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
  }
}

//Fonction qui créé les contacts des fiches VCF
async function createContactVcf (contact,index,that) {
  if(!that){
    that = this
  }
  try {
    await requestApi({method: 'POST', url: '/api/createContactVcf', params: {}, form: {contact : contact}, headers: {'Content-Type': 'application/json'}})
    that.contactsList[index].isContactCreated = true;
    toasterSuccess(`Le contact ${contact.firstname} ${contact.lastname} a été créé`,'Création de contact')
  } catch (error) {
    console.log(error)
    if(error.response != undefined){
      toasterError(`Impossible de créer le contact`,'Création de contact')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
    return new Promise((resolve, reject) => {
        new Vue().axios({
            method: options.method,
            url: conf.server + options.url,
            params: options.params,
            data: options.form,
            headers: options.headers,
            withCredentials: true
        }).then((response) => {
            resolve(response.data)
        }).catch((error) => {
            reject(error)
        })
    })
}

export default {
  analyzeContact,
  loadingClient,
  expandClientInfo,
  createAccess,
  createContactVcf,
  deleteAccess,
  connectOnClient,
  detailsTiers,
  updateFields,
  addContact,
  delContact,
  visualDevisTiers,
  visualFacTiers,
  deleteTiers,
  openAjoutExtranet,
  addMassiveContact,
  loadingDictionary,
  deletePropale,
  validateObject,
  toasterError,
  toasterSuccess,
}
